export default {"src":"/_next/static/media/fedex.f4154b78.svg","height":26,"width":85,"blurWidth":0,"blurHeight":0};